import * as React from "react";
import { forwardRef } from "react";
const SvgChevronStepsSeparator = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 35, height: 65, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#D9D9D9", d: "m8 0 18.632 32.9L8 64" }));
const ForwardRef = forwardRef(SvgChevronStepsSeparator);
export { ForwardRef as ReactComponent };
